import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { LiftsService } from '@app/lift/service/lifts.service';
import { batchesWithTools, lifts, slotWithBatches, tools, trayWithTools } from '@app/lift/mocks/lift.data';
import { Tray } from '@models/tray.model';
import { ToolService } from '@services/tool.service';
import { BatchService } from '@app/lift/service/batch.service';

@Injectable()
export class LiftMockInterceptor implements HttpInterceptor {

    liftLists = lifts;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return liftBackend(req.url, req.method, req, this.liftLists) || next.handle(req);
    }
}

export function liftBackend(url: string, method: string, request: HttpRequest<any>, liftList): Observable<HttpEvent<any>> {

    let lastSelectionId = -1;

    // Batches
    if (url.startsWith(BatchService.API_BATCHES_BASE_PATH)) {
        switch (method) {
            case 'GET':
                lastSelectionId = parseInt(url.slice(url.lastIndexOf('/') + 1, url.length), 0);
                const batch = batchesWithTools[lastSelectionId - 1];
                return new Observable(resp => {
                    resp.next(new HttpResponse<any>({
                        status: 200,
                        body: batch
                    }));
                    resp.complete();
                });

            case 'POST': {
                const newBatch = batchesWithTools[0];
                newBatch.id = 1577;
                newBatch.name = request.body.name;
                return new Observable(resp => {
                    resp.next(new HttpResponse<any>({
                        status: 200,
                        body: newBatch
                    }));
                    resp.complete();
                });
            }

            case 'PATCH': {
                if (request.body.operation === 'add') {
                    lastSelectionId = parseInt(url.slice(url.lastIndexOf('/') + 1, url.length), 0);
                    request.body.id = lastSelectionId;
                    const newBatch = batchesWithTools[lastSelectionId - 1];
                    newBatch.tools.items.push({tools: request.body.tools});
                    return new Observable(resp => {
                        resp.next(new HttpResponse<any>({
                            status: 200,
                            body: newBatch
                        }));
                        resp.complete();
                    });
                } else if (request.body.operation === 'remove') {
                    lastSelectionId = parseInt(url.slice(url.lastIndexOf('/') + 1, url.length), 0);
                    const newBatch = batchesWithTools[lastSelectionId - 1];
                    return new Observable(resp => {
                        resp.next(new HttpResponse<any>({
                            status: 200,
                            body: newBatch
                        }));
                        resp.complete();
                    })
                }
            }
        }
    }


    // Tools
    if (url.startsWith(ToolService.API_TOOL_BASE_PATH)) {
        switch (method) {
            // Get tools
            case 'GET':
                const slotId = request.params.get('slotId');
                if (slotId) {
                    // Return tools for specific slot
                    return new Observable(resp => {
                        resp.next(new HttpResponse<any>({
                            status: 200,
                            body: tools
                        }));
                        resp.complete();
                    });
                } else {
                    // Return tools for tableConfig
                    return new Observable(resp => {
                        resp.next(new HttpResponse<any>({
                            status: 200,
                            body: tools
                        }));
                        resp.complete();
                    });
                }
        }
    }

    // Trays
    if (url.indexOf(LiftsService.API_LIFTS_BASE_PATH) === -1) {
        return
    }

    try {
        // tslint:disable-next-line:radix
        lastSelectionId = parseInt(url.slice(url.lastIndexOf('/') + 1, url.length));
    } catch (e) {
    }

    // GET lifts
    if (url.endsWith(LiftsService.API_LIFTS_BASE_PATH) && method === 'GET') {
        return new Observable(resp => {
            resp.next(new HttpResponse<any>({
                status: 200,
                body: liftList
            }));
            resp.complete();
        });
    }
    // GET lift by id
    if (url.startsWith(LiftsService.API_LIFTS_BASE_PATH) && method === 'GET' && lastSelectionId > 0 && url.indexOf('trays') === -1) {
        const selectedLift = liftList.filter((lift) => lift.id === lastSelectionId)[0];
        return new Observable(resp => {
            resp.next(new HttpResponse<any>({
                status: 200,
                body: selectedLift
            }));
            resp.complete();
        });

    }
    // Create a lift
    if (url.endsWith(LiftsService.API_LIFTS_BASE_PATH) && method === 'POST') {
        const newLift = request.body;
        newLift.id = 74;
        liftList.push(newLift);
        return new Observable(resp => {
            resp.next(new HttpResponse<any>({
                status: 200,
                body: newLift
            }));
            resp.complete();
        });
    }

    // Delete a lift
    if (url.startsWith(LiftsService.API_LIFTS_BASE_PATH) && method === 'DELETE' && lastSelectionId > 0 && url.indexOf('trays') === -1) {
        const selectedLift = liftList.filter((lift) => lift.id === lastSelectionId)[0];
        return new Observable(resp => {
            resp.next(new HttpResponse<any>({
                status: 200,
                body: selectedLift
            }));
            resp.complete();
        });
    }

    // Rename a lift
    if (url.startsWith(LiftsService.API_LIFTS_BASE_PATH) && method === 'PUT' && lastSelectionId > 0 && url.indexOf('trays') === -1) {
        const selectedLift = request.body;
        return new Observable(resp => {
            resp.next(new HttpResponse<any>({
                status: 200,
                body: selectedLift
            }));
            resp.complete();
        });
    }

    // Trays
    if (url.startsWith(LiftsService.API_LIFTS_BASE_PATH) && url.indexOf('trays') > 0 && url.indexOf('slots') === -1) {

        switch (method) {
            // Add tray to lift
            case 'POST':
                const trayCount = parseInt(request.body, 0);
                const tray = new Tray({
                    id: Math.floor(Math.random() * 140),
                    slots: Array(trayCount).fill(null).map((value, index, array) => ({
                        id: index,
                        name: 'S' + index,
                    }))
                });

                tray.slots[0].hasTools = true;
                tray.slots[4].hasTools = true;
                return new Observable(resp => {
                    resp.next(new HttpResponse<any>({
                        status: 200,
                        body: tray
                    }));
                    resp.complete();
                });

            // Delete tray
            case 'DELETE':
                // Remove tray from lift
                return new Observable(resp => {
                    resp.next(new HttpResponse<any>({
                        status: 200,
                        body: {id: lastSelectionId}
                    }));
                    resp.complete();
                });

            // Change tray status
            case 'PATCH':
                // Remove tray from lift
                return new Observable(resp => {
                    resp.next(new HttpResponse<any>({
                        status: 200,
                        body: request.body
                    }));
                    resp.complete();
                });

            // Get tray details
            case 'GET':
                // Remove tray from lift
                trayWithTools.id = lastSelectionId;
                return new Observable(resp => {
                    resp.next(new HttpResponse<any>({
                        status: 200,
                        body: trayWithTools
                    }));
                    resp.complete();
                });
        }
    }

    // Slots
    if (url.startsWith(LiftsService.API_LIFTS_BASE_PATH) && url.indexOf('trays') > 0 && url.indexOf('slots') > 0) {

        switch (method) {
            // Get slot details
            case 'GET':
                slotWithBatches.id = lastSelectionId;
                // Remove tray from lift
                return new Observable(resp => {
                    resp.next(new HttpResponse<any>({
                        status: 200,
                        body: slotWithBatches
                    }));
                    resp.complete();
                });
        }
    }

}

